import React from 'react';

import { TransmissionEventTableProps } from '../types';

import { TransmissionEventChannels } from './TransmissionEventChannels';

export const TransmissionEventTable: React.FC<TransmissionEventTableProps> = ({
  isLoading,
  transmissionEvents,
  orderCreatedAt,
}) => {
  if (isLoading) return null;

  const hasTransmissionEvents = transmissionEvents.length > 0;

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-foreground">
        Transmission Events
      </h3>

      {hasTransmissionEvents ? (
        <TransmissionEventChannels
          transmissionEvents={transmissionEvents}
          orderCreatedAt={orderCreatedAt}
        />
      ) : (
        <p className="text-sm text-default-500">
          No transmission data available for this order.
        </p>
      )}
    </div>
  );
};
